abstract class Factory<T, R> {
  public abstract fromJson(resource: R): T;
}

export default Factory;
